import { render, staticRenderFns } from "./ISI.vue?vue&type=template&id=1a68c7be&"
import script from "./ISI.vue?vue&type=script&lang=js&"
export * from "./ISI.vue?vue&type=script&lang=js&"
import style0 from "./ISI.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports